import { useEffect, useState } from 'react'

import { fetchCalendarDaysOff } from 'api/annualCalendar'

import { setCalendar } from './scoring'

const iso = (d) => d.toISOString().slice(0, 10)
let loading = null

// Loads the Annual Calendar's days off once per visit (the last ~13 months,
// enough for the scorecard's six months and any Attendance week) and hands
// them to scoring.js. Returns 'loading', then 'ok' — or 'failed', when
// scoring.js keeps the old preschool holiday list. A page waits for it to
// settle so nothing is counted with the wrong days off first.
const useCalendarDaysOff = () => {
  const [status, setStatus] = useState('loading')
  useEffect(() => {
    let active = true
    if (!loading) {
      const today = new Date()
      loading = fetchCalendarDaysOff({
        from: iso(new Date(today.getTime() - 380 * 864e5)),
        to: iso(new Date(today.getTime() + 15 * 864e5))
      })
        .then((data) => {
          setCalendar(data)
          return true
        })
        .catch(() => {
          loading = null
          return false
        })
    }
    loading.then((ok) => active && setStatus(ok ? 'ok' : 'failed'))
    return () => {
      active = false
    }
  }, [])
  return status
}

export default useCalendarDaysOff
